// extracted by mini-css-extract-plugin
export default {"card":"BillsListItem_card__saULo","card__description":"BillsListItem_card__description__h8n6R"};